// Date / Time lib
import moment from "moment";
/**
 * Get formatted date
 * @param value
 */
export var getFormattedDate = function (value) {
    return value ? new Date(moment(value).format("YYYY/MM/DD")) : null;
};
//# sourceMappingURL=inputForm.core.js.map